import { fillableElements, FormRestructureEvent } from "../core/";

/**
* @param {EventTarget?} obj
*/
function onFormFieldValueUpdated(obj) {
  if (!obj || !(obj instanceof HTMLElement) || !obj.matches(fillableElements)) return;
  const target = /** @type {HTMLElement & { value: string }} */ (obj);
  let value = target.value;

  // Check for data-inputmask-mask
  const mask = target.dataset.inputmaskMask;

  if (mask && "inputmask" in target) {
    const inputMask = /** @type {{unmaskedvalue: () => string}} */ (target.inputmask);
    if (inputMask) {
      value = inputMask.unmaskedvalue();
    }
  }

  const hasNoValue = value.trim() === '';
  
  if (!hasNoValue) {
    target.classList.add('field-filled');
    target.classList.remove('error');
  } else {
    target.classList.remove('field-filled');
  }
}

/**
 * @param {HTMLFormElement} form 
 */
export function addFieldFilled(form) {
  form.addEventListener("restructure", event => {
		if (!(event instanceof FormRestructureEvent)) return;

    const eventTypes = ['input', 'change', 'blur'];
    for (const entry of event.added) {
      if (!entry.field) continue;
      for (const node of entry.field.querySelectorAll(`:scope ${fillableElements}`)) {
        const element = /** @type {HTMLElement} */ (node);
        eventTypes.forEach(ev => {
          element.addEventListener(ev, e => onFormFieldValueUpdated(e.target));
        });
        onFormFieldValueUpdated(element);
      }
    }
  });
}
